import script from "./SettledBet.vue?vue&type=script&setup=true&lang=js"
export * from "./SettledBet.vue?vue&type=script&setup=true&lang=js"

import "./SettledBet.vue?vue&type=style&index=0&id=64242fbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64242fbc"]])

export default __exports__